import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TError, TGcsUploadRow } from '@onesource/schemas';
import { ENTITY } from '../entity';

export const useGetMyGcsUploadsQueryKey = (blockId: string) => [ENTITY, 'gcs-uploads', 'block', blockId, 'mine'];

export const useGetMyGcsUploadsByBlock = (blockId: string) => {
  return useQuery<TGcsUploadRow[], TError>({
    queryKey: useGetMyGcsUploadsQueryKey(blockId),
    queryFn: async () => {
      const res = await axios.get<TGcsUploadRow[]>(`/community-hub/gcs-uploads/block/${blockId}/my-uploads`);
      return res.data;
    },
    enabled: !!blockId,
  });
};
